import dayjs from "dayjs";

import { Field } from "./collectionFields";

import axiosInstance from "../axiosInstance";

export type Item = Record<string, any>;

export interface CollectionPayload {
  data: {
    items: Item[];
    nbItems: number;
    total: number;
  };
  fields: Field[];
  limit: number;
  page: number;
  loading: boolean;
  collectionId: string;
  admin: boolean;
}

export const transformItem = (item: Item, fields: Field[]) => {
  let newItem = { ...item, key: item.id };
    
  fields.forEach((field) => {
    if (field.type === "timestamp" && item[field.name]) {
      newItem = {
        ...newItem,
        [field.name]: dayjs(item[field.name])

      };
    }
    else if (field.type === "date" && item[field.name]) {
      newItem = {
        ...newItem,
        [field.name]: dayjs(
          new Intl.DateTimeFormat("fr-CA").format(
            new Date(
              item[field.name].indexOf("T") > -1
                ? ""
                : item[field.name] + "T00:00:00.000Z"
            )
          ),
          "YYYY-MM-DD",
          true
        ),
      };
    } else {
      newItem = { ...newItem, [field.name]: item[field.name] };
    }
  });

  return newItem;
}

export const getCollectionItems = async (
  collectionId: string,
  fields: Field[],
  searchParams: string
) => {
  if (!searchParams.includes("sort=") && collectionId === "transactions_fao") {
    searchParams = searchParams + "&sort=-Date_Transaction";
  }
  const response = await axiosInstance.get(
    `https://melcarnedirectus2.digipulse.ch/items/${collectionId}?meta=*&fields[]=id,${fields
      .map((field) => field.name)
      .join(",")}&${searchParams}`
  );
  const data = response.data.data;

  const transformedItems = data.map((row: Item) => transformItem(row, fields));

  return {
    items: transformedItems,
    nbItems: response.data.meta.filter_count,
    total: response.data.meta.total_count,
  };
};

export type ItemChanges = Record<string, any>;

export const saveItemChanges = async (
  id: number,
  collectionId: string,
  changes: ItemChanges
) => {
  return await axiosInstance.patch(
    `https://melcarnedirectus2.digipulse.ch/items/${collectionId}/${id}`,
    changes
  );
};

export const createItem = async (
  collectionId: string,
  changes: ItemChanges
) => {
  return await axiosInstance.post(
    `https://melcarnedirectus2.digipulse.ch/items/${collectionId}`,
    changes
  );
};

export const duplicateItems = async (ids: string[]) => {
  await Promise.all(
    ids.map((id) =>
      axiosInstance.post(
        `https://melcarnebackend.digipulse.ch/duplicate_transaction`,
        { body: { key: id } }
      )
    )
  );
};

export const refreshAdresses = async (ids: string[]) => {
  await Promise.all(
    ids.map((id) =>
      axiosInstance.post(
        `https://melcarnebackend.digipulse.ch/refresh_address`,
        { body: { key: id } }
      )
    )
  );
};

export const refreshAddressFromParcelle = async (id: string) => {
  return await axiosInstance.post(
    `https://melcarnebackend.digipulse.ch/refresh_address_biens_off_market`,
    { body: { key: id } }
  );
};

export const deleteItem = async (
  id: number,
  collectionId: string
) => {
  return await axiosInstance.delete(
    `https://melcarnedirectus2.digipulse.ch/items/${collectionId}/${id}`
  );
};
